export const environment = {
	production: true,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	Use_Analytics: true,
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',

	//test setup
	BASE_URL_PROFILE: "/hec-profile-rest/rest/",
	BASE_URL_COMMON: "/hec-common-rest/rest/",
	BASE_URL_PUCA: "/hec-das-rest/rest/",
	BASE_URL_HRD_PUCA: "/hec-hrd-rest/rest/",
	BASE_URL_HRD: "/hec-hrd-rest/rest/", 
	BASE_URL_RPT: "/hec-rpt-rest/rest/",
	firebase: {
		apiKey: "AIzaSyDlfzULpcc-YpSuZp4sDct7y7lJGpe0j8Y",
		authDomain: "hec-project-9307e.firebaseapp.com",
		databaseURL: "https://hec-project-9307e.firebaseio.com",
		projectId: "hec-project-9307e",
		storageBucket: "hec-project-9307e.appspot.com",
		messagingSenderId: "983835680141",
		appId: "1:983835680141:web:5d2e4ddbd335b1395871c4",
		measurementId: "G-F3YCKCN2TT"
	},

	JWT: "jwt",

	version: 9.0,
	puca_batch: 66,
};
